import React from 'react';
import { Alert, Icon } from 'antd';
import api from '../../../config/api';
import { network, generators, asserts } from '../../../utils';
import { useDidMount } from '../../use';
import { message } from '../../biz';

import './Overdue.less';

const { generatorObject } = generators;

export default ({ className }) => {
  const [overdue, setOverdue] = React.useState(null);
  const [msg, setMsg] = React.useState('');
  const fetch = async () => {
    const response = await network({
      url: api.core.overDue,
      method: 'get',
    });
    if (response.success) {
      if (!response.data.success) {
        message.error(response.data.message);
        return;
      }
      const { isOverDue } = generatorObject(response.data.data);
      if (isOverDue) {
        const { resConfigs } = generatorObject(response.data.data) || [];
        if (asserts.isExist(resConfigs)) {
          const { conDes } = resConfigs[0] || {};
          setMsg(conDes);
        } else {
          setMsg(
            '温馨提示：您的货款已到期，为避免信用受影响，请尽快支付，若已回款，请忽略此信息。',
          );
        }
      }
      setOverdue(generatorObject(response.data.data).isOverDue);
    }
  };

  useDidMount(() => {
    fetch();
  });
  return (
    <div className={`header-overdue-alert ${overdue ? 'overdue-visible' : ''} ${className || ''}`}>
      <Alert message={msg} icon={<Icon type="flag" />} type="error" closable showIcon />
    </div>
  );
};
